var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":_vm._f("toISODate")(_vm.date)},on:{"input":value => _vm.date = value}})
}
var staticRenderFns = []

export { render, staticRenderFns }